import { useTheme } from '@mui/material';

interface IProps {
  size: number;
  color?: string;
}

export const WorldHeartIcon = ({ size, color }: IProps) => {
  const theme = useTheme();
  return (
    <svg id="worldhearticon__assets-icons-v2__svg__l11"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color ?? theme.palette.common.black}
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-world-heart"
    role="img"
    aria-hidden="true">
      
      <path id="worldhearticon__assets-icons-v2__path__l25" stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path id="worldhearticon__assets-icons-v2__path__l26" d="M21 12a9 9 0 1 0 -9.679 8.974" />
      <path id="worldhearticon__assets-icons-v2__path__l27" d="M3.6 9h16.8" />
      <path id="worldhearticon__assets-icons-v2__path__l28" d="M3.6 15h6.9" />
      <path id="worldhearticon__assets-icons-v2__path__l29" d="M11.5 3a17 17 0 0 0 0 18" />
      <path id="worldhearticon__assets-icons-v2__path__l30" d="M12.5 3a16.983 16.983 0 0 1 2.556 8.136" />
      <path id="worldhearticon__assets-icons-v2__path__l31" d="M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z" />
    </svg>);

};